import * as ReactModal from 'react-modal';

import { useDisableBodyScrollEffect } from '@hook/useDisableBodyScrollEffect';
import { UserMenuLinks, UserMenuLink } from '@components/UserMenuLinks';

import s from './MobileBottomBarUserMenu.sss';

export { UserMenuLink } from '@components/UserMenuLinks';

interface Props {
  isOpen: boolean,
  onClose: () => void,
  links: UserMenuLink[],
}

export const MobileBottomBarUserMenu: React.FC<Props> = ({
  isOpen,
  links,
  onClose,
}) => {
  useDisableBodyScrollEffect(isOpen);

  return (
    (
      <ReactModal
        ariaHideApp={false}
        className={{
          base: s.root,
          afterOpen: s.afterOpen,
          beforeClose: s.beforeClose,
        }}
        overlayClassName={{
          base: s.overlay,
          afterOpen: s.afterOpen,
          beforeClose: s.beforeClose,
        }}
        htmlOpenClassName={s.htmlOpen}
        bodyOpenClassName={s.bodyOpen}
        closeTimeoutMS={300}
        isOpen={isOpen}
        onRequestClose={onClose}
      >
        <UserMenuLinks links={links} />
      </ReactModal>
    )
  );
};
